export default {
  article: {
    title: 'USFans Spreadsheet: Kompletny poradnik i centrum zasobów',
    quickAnswerLabel: 'Szybka odpowiedź',
    quickAnswer: 'USFans Spreadsheet to pojedyncze, uporządkowane źródło, które grupuje popularne amerykańskie gadżety i odzież dla fanów w przejrzyste kategorie. Zamiast otwierać dziesiątki kart lub zgadywać, gdzie szukać, możesz przejść bezpośrednio do butów, bluz, koszulek sportowych i akcesoriów za pomocą bezpośrednich linków — oszczędzając czas i utrzymując porządek w przeglądaniu.',
    intro: 'Niezależnie od tego, czy szukasz konkretnej koszulki sportowej, przeglądasz nowe sneakersy, czy po prostu jesteś ciekawy, co jest dostępne, USFans Spreadsheet został zaprojektowany, aby ułatwić odkrywanie. Ten poradnik wyjaśnia, czym jest spreadsheet, co można w nim znaleźć, jak go używać i dlaczego jest przydatnym punktem wyjścia dla fanów i kupujących.',
    secWhat: {
      title: 'Czym jest USFans Spreadsheet?',
      p1: 'USFans Spreadsheet to uporządkowany, katalog oparty na kategoriach amerykańskich gadżetów. Porządkuje popularne typy produktów — od obuwia i nakryć głowy po akcesoria i perfumy — w prostą, przejrzystą strukturę. Zamiast długiej, nieuporządkowanej listy, spreadsheet używa przejrzystych grup, dzięki czemu zawsze wiesz, gdzie szukać.',
      p2: 'Pomyśl o nim jak o pojedynczym punkcie wejścia. Każda kategoria ma swój własny bezpośredni link, co oznacza, że możesz przejść ze strony głównej do konkretnej kolekcji jednym kliknięciem. Celem jest zmniejszenie tarcia i pomoc w szybszym znalezieniu tego, czego chcesz.',
    },
    secFind: {
      title: 'Co można znaleźć w środku',
      p1: 'Spreadsheet obejmuje szeroki zakres kategorii odzieży i akcesoriów, w tym:',
    },
    secHow: {
      title: 'Jak korzystać z USFans Spreadsheet',
      p1: 'Korzystanie ze spreadsheetu jest proste. Na stronie głównej wybierz kategorię z listy rozwijanej lub kliknij dowolną kartę kategorii. Zostaniesz przeniesiony bezpośrednio do pasującej kolekcji na głównej stronie. Ponieważ każda kategoria ma dedykowany, bezpośredni link, pomijasz zwykłe wyszukiwanie i filtrowanie.',
      p2: 'Aby uzyskać najszybsze doświadczenie, zacznij od listy rozwijanej, gdy dokładnie wiesz, czego chcesz, i używaj siatki, gdy wolisz przeglądać wizualnie.',
    },
    secPopular: {
      title: 'Popularne kategorie do odkrycia',
      p1: 'Niektóre kategorie są szczególnie popularne wśród odwiedzających. Obuwie to częsty punkt wyjścia dla fanów sneakersów, a bluzy i swetry pozostają ulubionym wyborem na wygodne, codzienne noszenie. Koszulki sportowe przyciągają kibiców, a akcesoria — od toreb po paski — oferują szybkie sposoby na dopełnienie stroju.',
      p2: 'Warto też poznać perfumy i zestawy, jeśli szukasz pomysłów na prezent lub skoordynowany wygląd. Każda kategoria prowadzi do dedykowanej kolekcji, więc możesz zagłębić się w obszar, który najbardziej Cię interesuje.',
    },
    secCompare: {
      title: 'USFans Spreadsheet vs. ręczne wyszukiwanie',
      p1: 'Poniższa tabela porównuje korzystanie z USFans Spreadsheet z ręcznym wyszukiwaniem na wielu stronach.',
      col1: 'USFans Spreadsheet',
      col2: 'Ręczne wyszukiwanie',
      col3: 'Najlepsze dla',
      r1factor: 'Organizacja',
      r1v1: 'Wysoka — przejrzyste kategorie',
      r1v2: 'Różna — zależy od wysiłku',
      r1best: 'Utrzymanie porządku',
      r2factor: 'Szybkość',
      r2v1: 'Szybko — bezpośrednie linki',
      r2v2: 'Wolniej — wiele kroków',
      r2best: 'Szybki dostęp',
      r3factor: 'Spójność',
      r3v1: 'Ujednolicona struktura',
      r3v2: 'Niespójna',
      r3best: 'Powtarzalne wizyty',
      r4factor: 'Krzywa uczenia się',
      r4v1: 'Niska',
      r4v2: 'Umiarkowana',
      r4best: 'Początkujący',
      r5factor: 'Aktualizacje',
      r5v1: 'Łatwe do odświeżenia',
      r5v2: 'Ręczne',
      r5best: 'Bycie na bieżąco',
    },
    secTips: {
      title: 'Wskazówki, jak uzyskać najwięcej wartości',
      tip1: 'Zacznij od kategorii, która pasuje do Twojego celu — wyszukiwanie jest najszybsze, gdy jesteś konkretny.',
      tip2: 'Użyj listy rozwijanej do szybkich skoków, a siatki do wizualnego przeglądania.',
      tip3: 'Dodaj stronę główną do zakładek, aby móc wrócić do zasobu, kiedy tylko potrzebujesz.',
      tip4: 'Zaglądaj ponownie po zaktualizowane poradniki i nowe kategorie.',
    },
    faq: {
      title: 'Często zadawane pytania',
      q1: 'Czym jest USFans Spreadsheet?',
      a1: 'To katalog oparty na kategoriach, który porządkuje popularne amerykańskie gadżety i odzież dla fanów w prostą, przejrzystą strukturę z bezpośrednimi linkami do każdej kolekcji.',
      q2: 'Czy przeglądanie spreadsheetu jest darmowe?',
      a2: 'Tak. Przeglądanie kategorii i czytanie poradników w tym zasobie jest całkowicie darmowe.',
      q3: 'Jak znaleźć konkretną kategorię?',
      a3: 'Użyj listy rozwijanej na stronie głównej, aby przejść do kategorii, lub kliknij dowolną kartę kategorii w siatce.',
      q4: 'Czy potrzebuję konta, aby z niego korzystać?',
      a4: 'Konto nie jest wymagane, aby przeglądać kategorie lub czytać poradniki.',
      q5: 'Dokąd prowadzą linki kategorii?',
      a5: 'Każdy link kategorii prowadzi do pasującej kolekcji na naszej głównej stronie, gdzie możesz zobaczyć produkty z tej kategorii.',
    },
    related: {
      title: 'Kontynuuj odkrywanie',
      text: 'Wróć na stronę główną, aby przeglądać wszystkie kategorie, lub odwiedź główną stronę bezpośrednio.',
    },
    ctaButton: 'Odwiedź główną stronę',
    backHome: 'Wróć do centrum USFans Spreadsheet',
    author: 'Zespół redakcyjny USFans',
    published: 'Opublikowano',
    updated: 'Zaktualizowano',
  },
};